export default "__VITE_ASSET__qQ7hEyj7__"